import { ProductLineCodesTypes } from '../business-lines/product-lines-codes';

export interface CatalogsRequest {
  customerId: number;
  productLine: ProductLineCodesTypes | number;
}
